import React from "react";
import AchievementsSection from "../../components/StudentWorld/Achievements.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const Achievement: React.FC = () => {
  return (
    <div>
       <MetaComponent
        title="Student’s Alumni Achievements and Success Stories | Aptech Limited."
        desc="Explore success stories of Aptech alumni in VFX, animation, beauty and wellness, IT, and gaming. Watch their achievements and see how Aptech has transformed their careers."
        keywords="aptech alumni success stories, alumni achievements, Aptech courses."
      />
      <AchievementsSection />
    </div>
  );
};

export default Achievement;
